import { EOrderOperaionStatus } from "../interfaces/api-so.interface"
import { EBonusType } from "./discount.model"
import { FirstApproveErrorMessage, FirstApproveErrorStatus } from "./error-message.model"

export interface SalesOrder {
  /* order ID, incremental
  * when generate a fake or  ordId it can be null
  * but api response must return not null
  */
  orderId?: number,

  /* order's SAP ID */
  sapOrderId?: string

  /* customer*/
  customerUuid: string
  customerCode?: string
  customerName?: string

  /* Customer_address */
  shipping?: SalesOrderShippingAddress

  /* Billing_address */
  billing?: SalesOrderBillingAddress

  /* When creating an order*/
  createTime: number

  /* When ord is marked as uploadable, called end_time in db. */
  seekingApprovalTime?: string

  /* When sending order to SAP time */
  uploadTime?: string

  /* Order pickup date, may be delivery date*/
  pickupDate?: number

  /* SRV, order sent to SAP time */
  sentToErpTime?: string

  docName?: string

  /* reference field, AKA custref for SAP uploading*/
  reference?: string

  /* note left for SO */
  note?: string

  /**
 * status of order
 * DRAFT
 * PENDING   , pending for confirmation after customer upload.
 * CONFIRMED, approved by sales and ready upload to SAP.
 * GENERATED , in SAP successfully.                      Confirmed for customer
 * DISPATCHED, generate invoice in SAP
 * CANCELLED
 */
  status: EOrderStatus

  /* sum of line price from each item*/
  totalPrice: string

  /* all items' tax */
  totalTax?: string

  /* order create SIQ user */
  salesIqUserId: string
  username?: string

  /* geolocation of SIQ user when creating order */
  lat?: number
  lng?: number

  /* customer visit boolean will set when user select customer and confirm the gps(update 04/05/2022) */
  geocheck?: boolean
  signin_time?: number

  /* delivery info */
  deliveryMobile?: string

  /* Edit by salesrep*/
  editBySales?: boolean

  /* sub status of GENERATED */
  updateQty?: boolean

  /* whether the order is rejected after PENDING_APPROVAL status*/
  isRejected?: number

  /* 0: not apply yet, 1: apply to supervisor or manager, 2: released*/
  isReleased?: boolean

  /* Check if minPrice > uom_s_price in Batches table.*/
  basePriceCheck?: Boolean

  /* Check if minPrice > uom_s_price in Batches table.*/
  insuffStockCheck?: Boolean


  /* Indicate which stage the order is between PENDING and CONFIRMED status*/
  /* remove it in omis 19/09/2022 by eric z
  // approvalStage?: number

  /* */
  isConfirmationEmail_required?: boolean
  erpUploadSuccess?: boolean
  is_failure_email_sent?: false
  retry_count?: number
  isuploadable?: boolean
  active?: boolean
  last_update_time?: number
  repId?: string
  // pi_uid
  invoiceNum?: number

  orderDetail?: SalesOrderItem[]

  discount_pct?: number //discount percentage

  //add on 21/07/2022 by Eric Zhang(new requirement from NL eric)
  customerCountry?: string //country name will come after generate
  detailCount?: number //will generate from backend
  validtill?: number //quotation valid date

  //add on 03/08/2022 because of the UK version (by Eric Zhang)
  //Five new fields and only display when approve:
  /*what kind of operation send in the request*/
  action?:EOrderOperaionStatus

  /*means this order can be upload to SAP(pass all the condition) */
  canConfirm?:boolean

  /* message about price updated or order amount is too large.
   * update 10/01/2023 update base on user want to see error msg abt approve, email and sap
   */
  message?:FirstApproveErrorMessage
  approved?:boolean
  approvestatus?:FirstApproveErrorStatus //similar to msg but use boolean for every result
  sendEmail?:boolean //will use in the pop up to show the email is sent or not
  sendToErpTime?:number
  source:EOrderSource

  /*upload to SAP successfully or not. */
  sapUploadResult?:boolean

  /*error message when upload to SAP */
  sapUploadMsg?:string

  /* provide by backend, will display in soup order list */
  processor?:string
  displayStatus?:EDiisplayStatus

  whsCode?:string //order list display use
  }

export interface SalesOrderShippingAddress {
  address1: string
  address2: string
  address3: string
  suburb: string
  postcode: string
  region: string
  city: string
  state: string
  country: string,
  customerAddressID:number
}

export interface SalesOrderBillingAddress {
  address1: string
  address2: string
  address3: string
  suburb: string
  postcode: string
  region: string
  city: string
  state: string
  country: string,
  customerAddressID:number
}


export interface SalesOrderItem {
  /* item index of current SO */
  lineId: number

  /* order item id, generated by server, unique */
  orderItemId?: number,

  /* order item UUID, locally generated, unique */
  orderItemUuid: string

  /* associated order's id */
  orderId?: number

  /* order item level note */
  note: string,

  /* sku info */
  skuId: number,
  skuName: string
  itemCode: string,
  expirationDate: string

  /* whse info */
  warehouseCode: string,
  warehouseName: string,

  /* qty of any uom of choice from user input */
  qty: number,

  /* uomCode in skuPack table */
  uomCode: number,

  /* total unit qty*/
  lineTotalQty: string,

  /* unit qty per carton when ordering */
  packSize: number,

  /* price of any uom of choice from user input ex. tax, pack price */
  price: number,

  /* total price of this line ex. tax */
  lineTotalPrice: string

  taxRate: number

  /* item level tax*/
  lineTotalTax: string

  /* whether to scan barcode or not (meat product) */
  barcode: boolean,

  /* discount percentage */
  discountPct: number

  /* mark the price is edit by user or not (ANZ only) add on 17/06/2022/eric */
  editPrice: boolean

  /*only use in bonus soi, wont store to db */
  bonusType?: EBonusType

  /**21/07/2022 update for new requirement from Eric Tse (edit by eric zhang) */
  cost?: number
}

export interface preferenceSalesOrder {
  ordId: number,

  /**label of the so
   * it wont provide if delete
   */
  favoriteName?: string,
}

export interface SoupOrderSelection {
  ordId: number,
  selectionType: ESoupOrderSelectionType
}

export enum ESoupOrderSelectionType {
  NORMAL = 'normal',
  DUPLICATE = 'duplicate',
  VIEW = 'view'
}

export enum EOrderSource {
  SIQCUST = 'SalesIQ-Cust',
  SIQSREP = "SalesIQ-Srep",
  SOUPSREP = 'SOUP-Srep',
  EDICUST = 'EDI-Cust'
}

export enum EOrderStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  GENERATED = 'GENERATED',
  DISPATCHED = 'DISPATCHED',
  CANCELLED = 'CANCELLED',
}

export enum EDiisplayStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  UPLOADED = 'UPLOADED',
  CANCELLED = 'CANCELLED'
}

export const fakseSOsInfo = [{
  orderId: 1,
  customerUuid: 'fake bp uuid 1',
  createTime: '312123901',
  totalPrice: '23394',
  status: EOrderStatus.DRAFT
},
{
  orderId: 2,
  customerUuid: 'fake bp uuid 2',
  createTime: '123451',
  totalPrice: '10000',
  status: EOrderStatus.PENDING
}]

export const fakeSODetail =
{
  orderId: 1,
  sapOrderId: 'fakeSAPSOId1',
  customerUuid: 'fake bp uuid 1',
  customerCode: 'fake bp code 1',
  customerName: 'fake bp name',
  createTime: '312123901',
  seekingApprovalTime: '12321312',
  uploadTime: '23121321',
  pickupDate: '31312123',
  piGenerateTime: '323123',
  sentToErpTime: '2312122',
  docName: 'fakeDoc name 1',
  reference: 'fake reference',
  note: 'fake note',
  status: EOrderStatus.DRAFT,
  totalPrice: '23394',
  totalCost: '23212',
  totalMovingAvgCost: '3221',
  totalTax: '1213',
  salesIqUserId: '990002',
  username: 'fake eric',
  lat: 123,
  lng: 11,
  driverName: 'fake driver eric',
  driverId: 'fake driver id',
  driverMobile: '0418321947',
  driverLicensePlate: '1dv2ka',
  deliveryName: 'fake deliver eric',
  deliveryAddress: 'fake deliver address A',
  deliveryMobile: 'fake deliver mobile',
  deliveryWaybillNo: 'fake delivery way bill no',
  submissiomId: 'fake submissionId',
  imgCount: 1,
  updateQty: false,
  accountCheck: false,
  isRejected: 1,
  isReleased: false,
  contractPickupDate: '23123233',
  prePayment: '112355',
  basePriceCheck: false,
  insuffStockCheck: false,
  approvalStage: 1,
  multiPickup: false,
  pickupPercent: 3,
  handlingFee: '23122',
  chargeFee: '312331',
  isConfirmationEmail_required: false,
  erpUploadSuccess: false,
  is_failure_email_sent: false,
  retry_count: 1,
  isuploadable: false,
  active: true,
  last_update_time: '14342321',
  repId: 'fake rep id'
  // pi_uid
}
